module.exports = __webpack_public_path__ + "static/gq-spend-get-phase2-web-homepage-banner-gemvnz-mobile-1fc4f200c901cdaa8ff9ce340f56d981.png";